<template>
  <div
    v-if="shouldShowReaction"
    key="reaction"
    class="h-6 sm:h-8 flex flex-row mb-4"
  >
    <div class="flex flex-row relative">
      <div v-if="displayOrder?.includes('Like')" class="relative z-[3]">
        <img
          data-testid="like-icon"
          :src="likeIcon"
          alt="Like Icon"
          class="h-6 sm:h-8 w-6 sm:w-8"
        />
      </div>
      <div
        v-if="displayOrder?.includes('Love')"
        :class="`relative z-[2] ${getLoveIconClass()}`"
      >
        <img
          data-testid="love-icon"
          :src="loveIcon"
          alt="Love Icon"
          class="h-6 sm:h-8 w-6 sm:w-8"
        />
      </div>
      <div
        v-if="displayOrder?.includes('Wow')"
        :class="`relative z-[1] ${getWowIconClass()}`"
      >
        <img
          data-testid="wow-icon"
          :src="wowIcon"
          alt="Wow Icon"
          class="h-6 sm:h-8 w-6 sm:w-8"
        />
      </div>
    </div>
    <div
      data-testid="reaction-number"
      :class="`${getTextIconClass()} content-center text-[#161313] font-krungsri text-xs relative my-[5px] sm:text-sm text-left font-medium`"
    >
      {{ reactionCount }}
    </div>
  </div>
</template>

<script lang="ts">
import likeIcon from "@/assets/images/reaction-like.png";
import loveIcon from "@/assets/images/reaction-love.png";
import wowIcon from "@/assets/images/reaction-wow.png";
import "@/assets/styles/reaction.css";
import type { FetchError } from "ofetch";
import { fetchReactionDetails } from "~/services/reaction-service";

export default {
  name: "Reaction",
  props: {
    contentId: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      likeIcon,
      loveIcon,
      wowIcon,
      reactionCount: "0",
      displayOrder: [] as string[],
      reactionError: null as FetchError | null,
      shouldShowReaction: false,
    };
  },
  async mounted() {
    await this.fetchReaction();
  },
  methods: {
    getLoveIconClass(): string {
      return this.displayOrder?.includes("Like") ? "one-icon-offset" : "";
    },
    getWowIconClass(): string {
      switch (this.displayOrder?.length) {
        case 3:
          return "two-icons-offset";
        case 2:
          return "one-icon-offset";
        default:
          return "";
      }
    },
    getTextIconClass(): string {
      switch (this.displayOrder?.length) {
        case 3:
          return "text-three-icons-offset";
        case 2:
          return "text-two-icons-offset";
        default:
          return "text-one-icon-offset";
      }
    },
    async fetchReaction(): Promise<void> {
      try {
        const { data: fetchedReactionData } = await fetchReactionDetails(
          this.contentId,
        );
        if (fetchedReactionData?.status == 204) {
          this.shouldShowReaction = false;
        }
        if (fetchedReactionData != null) {
          this.reactionCount = fetchedReactionData.display;
          this.displayOrder = fetchedReactionData.display_order;
          this.shouldShowReaction =
            !this.isLoading && this.reactionCount !== "0";
        }
      } catch (err) {
        // Display nothing in this case
        this.shouldShowReaction = false;
      }
    },
  },
};
</script>
